import { useEffect, useCallback } from "react";

export default function useFocusTrap(
  containerRef: React.RefObject<HTMLElement>,
  active: boolean,
) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!containerRef.current || !active) return;

      const focusableElements =
        containerRef.current.querySelectorAll<HTMLElement>(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (e.key === "Tab") {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          // Tab
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    },
    [containerRef, active],
  );

  useEffect(() => {
    if (active) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [active, handleKeyDown]);
}
